import React, { useState } from "react"
import StatisticCard from "components/common/statisiticCard/StatisticCard"
import { ArrowUp, DollarSign, Receipt, TrendingUp } from "lucide-react"
import TransactionDataTable from "@/components/transactionDataTable/TransactionDataTable"

const Synthese = () => {
  const [transactionStats, setTransactionStats] = useState({
    monthlyRevenue: 2450000,
    growthRate: 15.3,
    unusedBalance: 32450000,
  })

  const cardsData = [
    {
      title: "Revenu mensuel",
      total: transactionStats.monthlyRevenue,
      percentage: "18",
      icon: <DollarSign className="text-blue-800" strokeWidth={2.5} />,
      currency: "Fcfa",
    },
    {
      title: "Taux de croissance",
      total: transactionStats.growthRate,
      percentage: 2.1,
      icon: <TrendingUp className="text-blue-800" strokeWidth={2.5} />,
      isPercent: true,
    },
    {
      title: "Solde total non consommé",
      total: transactionStats.unusedBalance,
      percentage: 18,
      icon: <DollarSign className="text-blue-800" strokeWidth={2.5} />,
      currency: "Fcfa",
    },
  ]

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cardsData.map((card) => (
          <StatisticCard key={card.title} {...card} />
        ))}
      </div>

      <TransactionDataTable />
    </div>
  )
}

export default Synthese
